<template>
  <CollapsibleCard
    :value="true"
    :padding="false"
    collapsibleIcon="mdi-account-check-outline"
    collapsibleTitle="Egenkontroller"
    :total="total"
  >
    <template v-slot>
      <div v-if="!loading">
        <div
          class="caseCardContainer"
          v-for="(item, index) in data"
          :key="index"
        >
          <CaseCard
            :tile="true"
            :elevation="0"
            :title="item.name"
            :status="item.status"
            :color="getColor(item)"
            :deadline="item.deadLine"
            :under-right="item.assignedTo"
            :under-left="item.projectName"
            @click="goTo(item)"
          >
            <template v-slot:chips>
              <div v-for="(chip, index) in getChips(item)" :key="index">
                <v-chip class="mr-2" :color="chip.color" small>
                  {{ chip.title }}
                </v-chip>
              </div>
            </template>

            <template v-slot:underLeft>
              {{ item.projectName }}
              {{ item.projectName && item.houseNum ? "-" : "" }}
              {{ item.houseNum }}
            </template>
          </CaseCard>
        </div>
      </div>
      <div v-if="loading">
        <div v-for="index in 2" :key="index">
          <CaseCard :loading="true" />
        </div>
      </div>
      <ShowCollapsibleCardBtns
        :projectId="projectId"
        :houseName="houseName"
        filterNameProject="projectId"
        filterNameHouse="houseNum"
        routeName="Checkups"
      />
    </template>
  </CollapsibleCard>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";
import taskApi from "@/api/taskApi";

import CollapsibleCard from "@/components/shared/cards/CollapsibleCard.vue";
import ShowCollapsibleCardBtns from "@/components/shared/cards/ShowCollapsibleCardBtns.vue";
import CaseCard from "@/components/shared/cards/CaseCard.vue";

export default Vue.extend({
  props: {
    projectId: {
      default: "",
    },
    houseId: {
      default: null,
    },
    houseName: {
      default: null,
    },
  },
  data: () => ({
    data: [],
    total: 0,
    loading: true,
  }),
  async mounted() {
    await this.fetchData();
    this.$watch(
      () => this.$route.params,
      () => {
        // react to route changes...
        this.fetchData();
      }
    );
  },
  methods: {
    async fetchData() {
      this.loading = true;
      var headers = [
        {
          text: "Type",
          value: "taskType",
          type: "string",
          show: false,
          filterValues: ["2"],
          filterClause: 0,
          filterName: "taskType",
          removeFilter: true,
        },
        {
          text: "Ferdigmeld",
          value: "isCompleted",
          type: "boolean",
          show: true,
          filterValues: ["false"],
          filterClause: 0,
          filterName: "isCompleted",
        },
        {
          text: "Ansvarlig",
          value: "assignedTo",
          type: "string",
          show: true,
          filterValues: [this.profile.id],
          filterClause: 0,
          filterName: "assignedToId",
          disabled: true,
        },

        {
          text: "Opprettet",
          value: "createdDate",
          type: "date",
          show: true,
          filterValues: null,
          filterClause: 0,
          filterName: "createdDate",
          dateType: "DD.MM.YYYY",
        },
        {
          filterName: "projectId",
          filterValues: this.projectId ? [this.projectId] : "",
          show: true,
          type: "string",
        },
        {
          filterName: "houseId",
          filterValues: this.houseId ? [this.houseId] : "",
          show: true,
          type: "string",
        },
      ];

      var data = {
        headers: headers,
        itemsPerPage: 3,
        page: 1,
        search: "",
        sortBy: ["createdDate"],
        sortDesc: [true],
        hideLoader: true,
      };
      await taskApi
        .getTask(data)
        .then((response) => {
          this.data = response.items;
          this.total = response.totalCount;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    goTo(item) {
      this.$router.push({ name: "Checkup", params: { id: item.id } });
    },
    getChips(item: any) {
      var data = [
        {
          title: `${item.activitiesCompletedCount}/${item.activitiesCount} Fullført`,
          color: item.color,
          isCompleted: item.isCompleted,
        },
      ];

      if (item.completedDate) {
        data.push({
          title: item.tradeCodeName,
          color: "",
          isCompleted: false,
        });
      }
      return data;
    },
    getColor(item) {
      if (item?.color) {
        return item.color;
      } else if (item) {
        if (item.completedDate) {
          this.$set(item, "color", "success");
        } else if (
          item.activitiesCompletedCount === 0 &&
          item.activitiesCount > 0
        ) {
          this.$set(item, "color", "error");
        } else {
          this.$set(item, "color", "warning");
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
    }),
  },
  components: {
    CollapsibleCard,
    ShowCollapsibleCardBtns,
    CaseCard,
  },
});
</script>
